import { render, staticRenderFns } from "./greenmarking.vue?vue&type=template&id=be652c8c&scoped=true"
import script from "./greenmarking.vue?vue&type=script&lang=js"
export * from "./greenmarking.vue?vue&type=script&lang=js"
import style0 from "./greenmarking.vue?vue&type=style&index=0&id=be652c8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be652c8c",
  null
  
)

export default component.exports